<template>
  <div class="component_container">
    <!-- <div class="title_box">
      <img
        class="column_highlight_img"
        src="../assets/images/column_highlight.png"
        alt=""
      />
      资金情况
    </div> -->
    <div class="main_box">
      <!-- <div class="info">
        <div class="info_item">
          <span class="info_point"></span>
          <div class="info_title">民非</div>
          <div class="info_value"><span class="count">50</span></div>
        </div>
        <div class="info_item">
          <span class="info_point info_point3"></span>
          <div class="info_title">社会团体</div>
          <div class="info_value">
            <span class="count">{{ otherProjectBudget | countFilter }}</span
            >
          </div>
        </div>
        <div class="info_item">
          <span class="info_point info_point2"></span>
          <div class="info_title">基金会</div>
          <div class="info_value">
            <span class="count">{{ orgProjectBudget | countFilter }}</span
            >
          </div>
        </div>
        <div class="info_item">
          <span class="info_point info_point3"></span>
          <div class="info_title">社区社会组织</div>
          <div class="info_value">
            <span class="count">{{ otherProjectBudget | countFilter }}</span
            >
          </div>
        </div>
      </div> -->
      <div class="echarts_box">
        <highcharts id="echarts" :options="chartOptions"></highcharts>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CentetLeft1",
  props: {
    dataObj: {
      // type: Array,
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      govProjectBudget: 0, // 政府资金
      orgProjectBudget: 0, //社会资本
      otherProjectBudget: 0, // 其他
      chartOptions: {
        chart: {
          type: "pie",
          backgroundColor: "rgba(0,0,0,0)",
          borderWidth: 0,
          borderColor: "rgba(0,0,0,0)",
          margin: [0, 0, 0, 0],
          options3d: {
            enabled: true,
            alpha: 60,
            beta: 0,
          },
        },
        title: false,

        //鼠标放在饼图上显示的字
        tooltip: {
          headerFormat:
            '<span style="font-size: 16px; font-family:sans-serif;">社会组织类型</span><br/>',
          pointFormat: "{point.name}: <b>{point.percentage:.2f}%</b>",
          backgroundColor: "#fff",
          borderColor: null,
          borderRadius: 14,
          // padding: 10,
          useHTML: true,
          style: {
            fontStyle: "normal",
            color: "#666",
            fontSize: "14px",
            fontFamily: "sans-serif",
          },
        },
        //设置图表的表现效果 对整个图表生效。如果在series单独设置了样式，那么会被覆盖
        plotOptions: {
          pie: {
            states: {
              inactive: {
                opacity: 1,
              },
            },
            borderWidth: 0,
            allowPointSelect: false,
            cursor: "pointer",
            depth: 60,
            dataLabels: {
              enabled: false,
            },
            slicedOffset: 0,
            size: "235",
            events: {
              click: (e) => {
                let id;
                console.log(e.point.name);
                console.log(this.dataObj);
                //  this.dataObj
                if (e.point.name == "社区社会组织") {
                  id = 3;
                  this.$router.push({
                    path: "/orgTeam",
                    query: {
                      typeId: 2,
                      id: id,
                    },
                  });
                } else if (e.point.name == "基金会") {
                  id = 2;
                  this.$router.push({
                    path: "/orgTeam",
                    query: {
                      typeId: 1,
                      id: id,
                    },
                  });
                } else if (e.point.name == "民非") {
                  id = 0;
                  this.$router.push({
                    path: "/orgTeam",
                    query: {
                      typeId: 1,
                      id: id,
                    },
                  });
                } else if (e.point.name == "社会团体") {
                  id = 1;
                  this.$router.push({
                    path: "/orgTeam",
                    query: {
                      typeId: 1,
                      id: id,
                    },
                  });
                }
              },
            },
          },
        },
        //改变饼图默认颜色
        colors: [
          "rgb(189, 94, 38)",
          "rgb(196, 66, 9)",
          "rgb(26, 73, 255)",
          "rgb(233, 169, 51)",
        ],
        series: [
          {
            type: "pie",
            name: "",
            data: [
              { name: "民非", y: 20 },
              { name: "社会团体", y: 30 },
              { name: "基金会", y: 40 },
              { name: "社区社会组织", y: 50 },
            ],
          },
        ],

        // 去掉右下角链接
        credits: {
          enabled: false,
        },
      },
    };
  },
  mounted() {
    this.resetOption();
  },
  methods: {
    resetOption() {
      if (Object.keys(this.dataObj).length == 0) {
        return;
      }
      let series = [
        {
          type: "pie",
          name: "",
          borderWidth: 0,
          borderColor: null,
          dataLabels: {
            enabled: false,
          },

          data: this.dataObj,
        },
      ];
      this.chartOptions = { ...this.chartOptions, series };
    },
  },
  watch: {
    dataObj() {
      this.resetOption();
    },
  },
};
</script>

<style lang="less" scoped>
.component_container {
  width: 100%;
  height: 100%;
  color: #fff;
  padding-top: 1px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}
.title_box {
  position: relative;
  height: 41px;
  line-height: 41px;
  padding-left: 14px;

  .column_highlight_img {
    position: absolute;
    width: 22px;
    height: 41px;
    left: -9px;
    top: 0;
  }
}
.main_box {
  display: flex;
  // flex-grow: 1;
  .info {
    flex-shrink: 0;
    .info_item {
      position: relative;
      padding-left: 34px;
      padding-top: 10px;

      & + .info_item {
        margin-top: 10px;
      }
      .info_point {
        left: 13.2px;
        position: absolute;
        width: 11px;
        height: 11px;
        background: #e520fb;
        border-radius: 50%;

        &.info_point2 {
          background-color: #1543ff;
        }
        &.info_point3 {
          background-color: #35cfe8;
        }
        &.info_point4 {
          background-color: #8246fe;
        }
      }
      .info_title {
        height: 15px;
        font-size: 14px;
        line-height: 15px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #ffffff;
      }
      .info_value {
        margin-top: 6px;
        height: 16px;
        font-size: 18px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #fff;

        .count {
          color: #f8e61d;
        }
      }
    }
  }

  .echarts_box {
    flex-grow: 1;
    height: 100%;
    #echarts {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
